import { render, staticRenderFns } from "./CandidateUpload.vue?vue&type=template&id=d0cfafcc"
import script from "./CandidateUpload.vue?vue&type=script&lang=js"
export * from "./CandidateUpload.vue?vue&type=script&lang=js"
import style0 from "./CandidateUpload.vue?vue&type=style&index=0&id=d0cfafcc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0cfafcc')) {
      api.createRecord('d0cfafcc', component.options)
    } else {
      api.reload('d0cfafcc', component.options)
    }
    module.hot.accept("./CandidateUpload.vue?vue&type=template&id=d0cfafcc", function () {
      api.rerender('d0cfafcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CandidateUpload.vue"
export default component.exports